const STORAGE_KEY = 'signalbridge.phone.audioDevices';

const BASE_AUDIO_CONSTRAINTS = {
  channelCount: 1,
  echoCancellation: true,
  noiseSuppression: true,
};

export function loadPhoneAudioSettings() {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
    return {
      micDeviceId: typeof parsed.micDeviceId === 'string' ? parsed.micDeviceId : '',
      speakerDeviceId: typeof parsed.speakerDeviceId === 'string' ? parsed.speakerDeviceId : '',
    };
  } catch (_) {
    return { micDeviceId: '', speakerDeviceId: '' };
  }
}

export function savePhoneAudioSettings(next = {}) {
  const merged = {
    ...loadPhoneAudioSettings(),
    ...next,
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(merged));
  } catch (_) {
    /* ignore quota / private mode */
  }
  return merged;
}

export function buildMicConstraints(micDeviceId) {
  if (micDeviceId) {
    return {
      ...BASE_AUDIO_CONSTRAINTS,
      deviceId: { exact: micDeviceId },
    };
  }
  return { ...BASE_AUDIO_CONSTRAINTS };
}

/** Same permission + enumerate path RTP paging uses so device labels are populated. */
export async function requestAudioPermission() {
  if (!navigator.mediaDevices?.getUserMedia) return false;
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: BASE_AUDIO_CONSTRAINTS,
    });
    stream.getTracks().forEach((track) => track.stop());
    return true;
  } catch (_) {
    return false;
  }
}

export async function listBrowserAudioDevices() {
  if (!navigator.mediaDevices?.enumerateDevices) {
    return { inputs: [], outputs: [] };
  }
  const devices = await navigator.mediaDevices.enumerateDevices();
  return {
    inputs: devices.filter((d) => d.kind === 'audioinput' && d.deviceId),
    outputs: devices.filter((d) => d.kind === 'audiooutput' && d.deviceId),
  };
}
